/// @flow
import React from 'react'
import type { Node } from 'react'
import Helmet from 'react-helmet'
import { SITE_NAME } from '../config'

type PageProps = {
  description: ?string,
  image: ?string,
  host: ?string,
  url: ?string,
  noCrawl: ?boolean,
  published: ?Date,
  title: ?string,
  id: string,
  children: ?Node
}
function Page ({ description, image, host, url, noCrawl, published, title, id, children }: PageProps) {
  const getMeta = () => {
    const metaTagTitle = title ? title.substring(0, 60) : SITE_NAME

    const meta = [
      { itemprop: 'name', content: metaTagTitle },
      { itemprop: 'description', content: description },
      { itemprop: 'image', content: image },
      { name: 'description', content: description },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: metaTagTitle },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image:src', content: image },
      { name: 'twitter:domain', content: host },
      { property: 'og:title', content: metaTagTitle },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: url },
      { property: 'og:image', content: image },
      { property: 'og:image:width', content: '2300' },
      { property: 'og:image:height', content: '2300' },
      { property: 'og:description', content: description },
      { property: 'og:site_name', content: SITE_NAME }
    ]

    if (noCrawl) {
      meta.push({ name: 'robots', content: 'noindex, nofollow' })
    }

    if (published) {
      meta.push({ name: 'article:published_time', content: published })
    }
    return meta
  }

  const meta = getMeta()
  return (
    <div id={id}>
      <Helmet
        htmlAttributes={{
          lang: 'en',
          itemscope: undefined,
          itemtype: 'http://schema.org/WebPage'
        }}
        title={title || SITE_NAME}
        link={[
          {
            rel: 'canonical',
            href: url
          }
        ]}
        meta={meta}
      />
      {children}
    </div>
  )
}
export default Page
